export const adminRoutes = [
  {
    path: "dashboard",
    label: "Dashboard",
  },
  {
    path: "customer",
    label: "Customer",
  },
  {
    path: "merchant",
    label: "Merchant",
  },
  {
    path: "settings",
    label: "Settings",
  },
  {
    path: "report",
    label: "Transactions",
  },
  {
    path: "topup-transactions",
    label: "Top Up Transactions",
  },
  {
    path: "push-notification",
    label: "Push Notification",
  },
  {
    path: "physical-card",
    label: "Physical Card",
  },
  {
    path: "dispute",
    label: "Dispute",
  },
  {
    path: "events",
    label: "Events",
  },
  {
    path: "manage-outlet",
    label: "Manage Outlet",
  },
  {
    path: "amd-membership",
    label: "Al Maha Drive",
  },
  {
    path: "yacht-club",
    label: "Lusail Yacht Club",
  },
  {
    path: "manage-parks",
    label: "Manage Parks",
  },
  {
    path: "promotion",
    label: "Promotions",
  },
  {
    path: "aqua",
    label: "Aqua Slot Management",
  },
  {
    path: "privilege-account",
    label: "Privilege Account",
  },
  {
    path: "lww-ticket",
    label: "LWW Ticket",
  }
];

export const physicalCardRoutes = [
  {
    path: "physical-card",
    label: "Physical Card",
  },
];

export const financeRoutes = [
  {
    path: "dispute",
    label: "Dispute",
  },
  {
    path: "report",
    label: "Transactions",
  },
];

export const marketingRoutes = [
  {
    path: "push-notification",
    label: "Push Notification",
  },
  {
    path: "events",
    label: "Events",
  },
  {
    path: "amd-membership",
    label: "Al Maha Drive",
  },
  {
    path: "manage-parks",
    label: "Manage Parks",
  },
  {
    path: "promotion",
    label: "Promotions",
  },
  // {
  //   path: "lusail-winter-wonderland",
  //   label: "LWW Categories",
  // },
];

export const aquaManagerRoutes = [
  {
    path: "aqua",
    label: "Aqua Slot Management",
  },
];

export const lwwTicketRoutes = [
  {
    path: "lww-ticket",
    label: "LWW Ticket",
  },
];
